import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import Slider from 'react-slick';
import YouTube from 'react-youtube';

import {
	useCallback,
	useEffect,
	useState,
} from 'react';

import {
	trackPage,
	trackVideo,
} from '../adobeAnalytics';
import { useAnalyticsContext } from '../components/AnalyticsContext';
import FooterNav from '../components/FooterNav';
import I18n from '../components/I18n';
import { useLocale } from '../Locale';

import YoutubeVideoStore from '../state/YoutubeVideoStore';
import { view } from '@risingstack/react-easy-state';

const SingleVideo = (props) => {
	const context = useAnalyticsContext();
	const onReady = (event)=>{
		YoutubeVideoStore.players.push(event.target)
		YoutubeVideoStore.setPlayers(YoutubeVideoStore.players)
	}

	const onPlay = useCallback(() => {
		trackVideo(context.componentName, false, props.item.trackingName, 'play');
	}, [context.componentName, props.item.trackingName]);

	const onComplete = useCallback(() => {
		trackVideo(context.componentName, false, props.item.trackingName, 'complete');
	}, [context.componentName, props.item.trackingName]);

	const onPause = useCallback(() => {
		trackVideo(context.componentName, false, props.item.trackingName, 'pause');
	}, [context.componentName, props.item.trackingName]);

	const opts = {
		playerVars: {
		  rel: 0,
		},
	  };
	return (
		<div className={'single-video'}>
			<div className="single-video-content">
				<h3>{props.item.title}</h3>
				<div className="iframe-wrapper">
					<YouTube videoId={props.item.embedId} onPlay={onPlay} onEnd={onComplete} onPause={onPause} opts={opts} onReady={onReady} />
				</div>
			</div>
		</div>
	);
};

const videos = [
	{
		id: 6,
		title: 'Nissan Patrol 2022 - The Story Of The Conqueror',
		trackingName: 'storyoftheconqueror',
		embedId: '_3piEVqzJAY',
	},
	{
		id: 1,
		title: 'Nissan - The Official Automotive Partner of Expo 2020',
		trackingName: 'officialpartner',
		embedId: 'yUO9yWyXk2w',
	},
	{
		id: 2,
		title: 'Advanced Vision of Nissan Intelligent Mobility',
		trackingName: 'advancedvision',
		embedId: 'k6G-NyLoT0Y',
	},
	// {
	// 	id: 3,
	// 	title: 'Celebrating 10 Years of Electrification',
	// 	trackingName: 'celebrating10years',
	// 	embedId: 'WFzembpiicU',
	// },
	{
		id: 4,
		title: 'A New Day for Nissan',
		trackingName: 'newdayfornissan',
		embedId: '7LgdE4j_XJw',
	},
	{
		id: 5,
		title: 'Nissan Ariya. The Next Gen-EV',
		trackingName: 'ariyanextgenev',
		embedId: 'IYkLjcQP26M',
	},
];

const Videos = () => {
	const locale = useLocale();

	const [index, setIndex] = useState(0);
	
	useEffect(()=>{
		//clear array on load
		YoutubeVideoStore.players = []
		YoutubeVideoStore.setPlayers([])
	},[]);

	useEffect(() => {
		trackPage(`${locale}|videos|${videos[index].trackingName}`, 'videos');
	}, [index, locale]);

	var settings = {
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		centerMode: true,
		dots:true,
		centerPadding: '400px',
		beforeChange() {
			
		},
		afterChange(index) {
			setIndex(index);
			YoutubeVideoStore.players.forEach((player) => {
				if(player){
					player.pauseVideo();
				}
			});
			
		},
		onSwipe() {},
		responsive: [
			{
				breakpoint: 1365,
				settings: {
					centerPadding: '150px',
				},
			},
			{
				breakpoint: 1023,
				settings: {
					centerPadding: '50px',
				},
			},
			{
				breakpoint: 767,
				settings: {
					centerMode: false,
				},
			},
		],
	};

	return (
		<div className={'container videos fullscreen lang-' + locale}>
			<div className="content">
				<div className="page-logo lg nissan white">NISSAN</div>
				<div className="videos-container">
					<div className="videos-container-content">
						<Slider {...settings}>
							{videos.map((video) => (
								<SingleVideo key={video.trackingName} item={video} />
							))}
						</Slider>
					</div>
				</div>
				{/* <div className="videos-instructions">
					<p>
						<I18n t="car.videoInstructions" />
					</p>
				</div> */}
			</div>
			<FooterNav currentPage={'videos'} prev={{ text: 'general.back', url: 'explore' }} />
		</div>
	);
};

export default view(Videos);
